import { useQuery } from "@tanstack/react-query";
import i18next from "i18next";
import { getWarehouses } from "../../api/apiInventory";

export const useGetWarehouses = (params) => {
    const { data, isLoading, error, refetch } = useQuery({
        queryKey: ["warehouses", params, i18next.language],
        queryFn: () => getWarehouses(params),
        keepPreviousData: true,
    });

    const root = data?.data;
    let warehouses = [];
    let meta = data?.meta;
    if (Array.isArray(root)) {
        warehouses = root;
    } else if (root && Array.isArray(root.data)) {
        warehouses = root.data;
        meta = meta || root.meta;
    }

    return {
        isLoading,
        error,
        warehouses,
        meta: meta || { current_page: 1, per_page: params?.per_page || 15, total: warehouses.length },
        refetch,
    };
};
